/* Neu Appliance Outlet — shared delivery coverage map + styled ZIP popup.
   Used by the PDP delivery section (neu-pdp-delivery) and the Local Delivery page
   (neu-delivery). Renders the brand popup (Figma 11578-2802): a navy bubble with a
   downward tail and three rows — Zip Code / Delivery (Un)Available / price-or-phone,
   with burnt-orange line icons + white bold text.

   Handles ANY 5-digit ZIP: in-zone ZIPs anchor to their KML polygon centroid; other
   ZIPs are geocoded so out-of-area ZIPs still get an anchored popup. ZIPs far from
   Austin show the popup over the current map view instead of flying the map away.

   Public API:
     window.NeuDeliveryMap.create({
       mapEl, input, form?, errEl?, onResult(result|null)
     })
   where each of mapEl/input/form/errEl is a CSS selector string OR an element, and
   result = { zip, available, price|null }. onResult(null) fires when the field clears. */
(function () {
  if (window.NeuDeliveryMap) return;

  var KEY = 'AIzaSyBNa3X4Rj-6JB-qmANLEGjGWBnyoCE-yBY';
  var KML_URL = 'https://cdn.shopify.com/s/files/1/0580/4523/5373/files/kml-map-update_d2789135-e86f-4d64-bbea-0be48e9c20f5_ike_update.kml?v=1713842365';
  var AUSTIN = { lat: 30.27, lng: -97.72 };

  // ZIP -> delivery price (verbatim from the legacy "Dynamic Delivery" tool).
  var PRICE = {
    "78701": "$45", "73301": "$99", "76537": "$149", "76530": "$149", "78602": "$149", "78619": "$125",
    "78669": "$149", "78642": "$125", "78620": "$125", "78615": "$125", "78610": "$99", "78702": "$45",
    "78703": "$45", "78705": "$45", "78712": "$45", "78721": "$45", "78722": "$45", "78723": "$45",
    "78727": "$45", "78728": "$45", "78729": "$45", "78730": "$45", "78731": "$45", "78741": "$45",
    "78746": "$45", "78750": "$45", "78751": "$45", "78752": "$45", "78753": "$45", "78754": "$45",
    "78756": "$45", "78757": "$45", "78758": "$45", "78759": "$45", "78717": "$75", "78660": "$75",
    "78613": "$75", "78617": "$75", "78652": "$99", "78664": "$75", "78665": "$75", "78719": "$75",
    "78725": "$75", "78726": "$75", "78733": "$99", "78737": "$99", "78739": "$99", "78744": "$75",
    "78745": "$75", "78747": "$75", "78748": "$75", "78749": "$75", "78735": "$45", "78732": "$99",
    "78742": "$45", "78704": "$45", "78724": "$45", "78654": "$149", "78676": "$149", "78666": "$149",
    "78644": "$149", "78530": "$149", "78633": "$125", "78605": "$149", "78653": "$75", "78634": "$99",
    "78681": "$75", "78734": "$99", "78736": "$99", "78738": "$125", "78621": "$125", "78626": "$125",
    "78640": "$125", "78641": "$99", "78645": "$125", "78612": "$125", "78628": "$99", "76574": "$125",
    "78616": "$125"
  };

  // ---- burnt-orange line icons (currentColor) ----
  var IC = {
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8.2 12 3 3 8.2l9 5.2 9-5.2Z"/><path d="M3 8.2v7.6l9 5.2 9-5.2V8.2"/><path d="M12 13.4V21"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6h11v9.5h-11z"/><path d="M13.5 9h3.7l3.3 3.3v3.2h-7z"/><circle cx="6.6" cy="18" r="1.9"/><circle cx="17.4" cy="18" r="1.9"/></svg>',
    dollar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M14.7 9.1c-.6-.9-1.6-1.3-2.7-1.3-1.5 0-2.7.8-2.7 2.1 0 1.2 1.1 1.8 2.7 2.1 1.6.3 2.8.9 2.8 2.2 0 1.3-1.2 2.1-2.8 2.1-1.2 0-2.3-.5-2.9-1.4M12 6.4v11.2"/></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6.4 3h3l1.5 4-2 1.4a11 11 0 0 0 4.7 4.7l1.4-2 4 1.5v3a2 2 0 0 1-2.1 2A16 16 0 0 1 4.4 5.1 2 2 0 0 1 6.4 3Z"/></svg>'
  };

  // ---- one-time popup CSS ----
  function ensureCss() {
    if (document.getElementById('neu-dmap-css')) return;
    var css = ''
      + '.neu-dmap-pop{position:absolute;pointer-events:none;}'
      + '.neu-dmap-pop__box{position:absolute;left:0;bottom:15px;transform:translateX(-50%);'
        + 'background:#261849;border-radius:20px;padding:20px !important;display:flex;flex-direction:column;gap:12px;'
        + 'white-space:nowrap;box-shadow:0 16px 38px rgba(38,24,73,.34);font-family:"Montserrat",system-ui,sans-serif;}'
      + '.neu-dmap-pop__row{display:flex;align-items:center;gap:12px;}'
      + '.neu-dmap-pop__ic{flex:none;width:28px;height:28px;color:#ea7614;display:flex;align-items:center;justify-content:center;}'
      + '.neu-dmap-pop__ic svg{width:28px;height:28px;display:block;}'
      + '.neu-dmap-pop__t{font-weight:700;font-size:20px;line-height:1.15;color:#fff;letter-spacing:.2px;}'
      + '.neu-dmap-pop__tail{position:absolute;left:0;top:-16px;transform:translateX(-50%);width:0;height:0;'
        + 'border-left:15px solid transparent;border-right:15px solid transparent;border-top:16px solid #261849;}'
      // out-of-area: one general (non-pinpointed) popup centered over the map
      + '.neu-dmap-gen{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1000;pointer-events:none;max-width:calc(100% - 32px);}'
      + '.neu-dmap-gen__box{background:#261849;border-radius:20px;padding:20px 24px !important;display:flex;flex-direction:column;gap:12px;'
        + 'box-shadow:0 16px 38px rgba(38,24,73,.34);font-family:"Montserrat",system-ui,sans-serif;}'
      + '.neu-dmap-gen .neu-dmap-pop__t{white-space:normal;}';
    var st = document.createElement('style');
    st.id = 'neu-dmap-css'; st.textContent = css;
    document.head.appendChild(st);
  }

  // ---- shared Google Maps loader (one script, many maps) ----
  var mapsPromise = null;
  function loadMaps() {
    if (mapsPromise) return mapsPromise;
    mapsPromise = new Promise(function (resolve, reject) {
      if (window.google && window.google.maps) { resolve(); return; }
      window.__neuMapsCb = function () { resolve(); };
      var s = document.createElement('script');
      s.async = true; s.defer = true;
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + KEY + '&callback=__neuMapsCb';
      s.onerror = function () { reject(new Error('maps')); };
      document.head.appendChild(s);
    });
    return mapsPromise;
  }

  function el(ref) { return typeof ref === 'string' ? document.querySelector(ref) : ref; }
  function kmlColor(c) { if (!c) return null; c = c.replace('#', ''); if (c.length < 8) return '#' + c; return '#' + c.slice(6, 8) + c.slice(4, 6) + c.slice(2, 4); }
  function miles(a, b) {
    var R = 3958.8, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180,
        la1 = a.lat * Math.PI / 180, la2 = b.lat * Math.PI / 180;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function popupHtml(zip, available, price) {
    var rows = available
      ? [[IC.box, 'Zip Code ' + zip], [IC.truck, 'Delivery Available'], [IC.dollar, 'Starting At ' + price]]
      : [[IC.box, 'Zip Code ' + zip], [IC.truck, 'Delivery Unavailable'], [IC.phone, 'Call (512) 992-2714']];
    var inner = rows.map(function (r) {
      return '<div class="neu-dmap-pop__row"><span class="neu-dmap-pop__ic">' + r[0] + '</span><span class="neu-dmap-pop__t">' + r[1] + '</span></div>';
    }).join('');
    return '<div class="neu-dmap-pop__box">' + inner + '</div><div class="neu-dmap-pop__tail"></div>';
  }

  // OverlayView popup (defined after google.maps is ready).
  function makePopup(map) {
    function Popup() { this.pos = null; var d = this.div = document.createElement('div'); d.className = 'neu-dmap-pop'; d.style.display = 'none'; }
    Popup.prototype = Object.create(google.maps.OverlayView.prototype);
    Popup.prototype.onAdd = function () { this.getPanes().floatPane.appendChild(this.div); };
    Popup.prototype.onRemove = function () { if (this.div.parentNode) this.div.parentNode.removeChild(this.div); };
    Popup.prototype.draw = function () {
      if (!this.pos) return;
      var p = this.getProjection().fromLatLngToDivPixel(this.pos);
      if (!p) return;
      this.div.style.left = p.x + 'px';
      this.div.style.top = p.y + 'px';
    };
    Popup.prototype.show = function (latlng, html) { this.pos = latlng; this.div.innerHTML = html; this.div.style.display = ''; this.draw(); };
    Popup.prototype.hide = function () { this.div.style.display = 'none'; this.pos = null; };
    var pop = new Popup(); pop.setMap(map); return pop;
  }

  function create(opts) {
    ensureCss();
    var mapEl = el(opts.mapEl);
    var input = el(opts.input);
    if (!mapEl) return;
    var onResult = opts.onResult || function () {};
    var errEl = opts.errEl ? el(opts.errEl) : null;

    loadMaps().then(function () {
      var map = new google.maps.Map(mapEl, { zoom: 9, center: AUSTIN, disableDefaultUI: true, zoomControl: true });
      var pop = makePopup(map);

      // General (non-pinpointed) out-of-area popup — centered over the map, not tied to a ZIP location.
      var genEl = document.createElement('div');
      genEl.className = 'neu-dmap-gen'; genEl.style.display = 'none';
      genEl.innerHTML = '<div class="neu-dmap-gen__box">'
        + '<div class="neu-dmap-pop__row"><span class="neu-dmap-pop__ic">' + IC.truck + '</span><span class="neu-dmap-pop__t">Neu Delivery Unavailable</span></div>'
        + '<div class="neu-dmap-pop__row"><span class="neu-dmap-pop__ic">' + IC.box + '</span><span class="neu-dmap-pop__t">3rd Party Delivery Available</span></div>'
        + '</div>';
      mapEl.appendChild(genEl);
      function showGeneral() { genEl.style.display = ''; }
      function hideGeneral() { genEl.style.display = 'none'; }
      var geocoder = new google.maps.Geocoder();
      var zoneByZip = {}, geoCache = {};

      fetch(KML_URL).then(function (r) { return r.text(); }).then(function (kml) {
        var xml = new DOMParser().parseFromString(kml, 'text/xml');
        var styles = {};
        [].forEach.call(xml.getElementsByTagName('Style'), function (s) {
          try {
            styles[s.getAttribute('id')] = {
              line: s.getElementsByTagName('LineStyle')[0].getElementsByTagName('color')[0].textContent,
              poly: s.getElementsByTagName('PolyStyle')[0].getElementsByTagName('color')[0].textContent
            };
          } catch (e) {}
        });
        [].forEach.call(xml.getElementsByTagName('Placemark'), function (pm) {
          var zip = ((pm.getElementsByTagName('name')[0] || {}).textContent || '').trim();
          var styleId = (((pm.getElementsByTagName('styleUrl')[0] || {}).textContent) || '').replace('#', '');
          var st = styles[styleId + '-normal'] || styles[styleId] || {};
          var stroke = kmlColor(st.line) || '#7947a8', fill = kmlColor(st.poly) || '#7947a8';
          var polys = [];
          [].forEach.call(pm.getElementsByTagName('Polygon'), function (pg) {
            var coordsText = (pg.getElementsByTagName('coordinates')[0] || {}).textContent || '';
            var path = coordsText.trim().split(/\s+/).map(function (c) { var p = c.split(','); return { lat: parseFloat(p[1]), lng: parseFloat(p[0]) }; }).filter(function (p) { return !isNaN(p.lat) && !isNaN(p.lng); });
            if (path.length < 3) return;
            var poly = new google.maps.Polygon({ paths: path, strokeColor: stroke, strokeOpacity: 0.85, strokeWeight: 1.5, fillColor: fill, fillOpacity: 0.35 });
            poly.setMap(map);
            poly.addListener('click', function () { if (input) input.value = zip; doLookup(zip); });
            polys.push(poly);
          });
          if (polys.length) zoneByZip[zip] = { polys: polys };
        });
      }).catch(function () {});

      function centroid(zip) {
        var z = zoneByZip[zip]; if (!z) return null;
        var b = new google.maps.LatLngBounds();
        z.polys.forEach(function (p) { p.getPath().forEach(function (pt) { b.extend(pt); }); });
        return b.getCenter();
      }
      function highlight(zip) {
        Object.keys(zoneByZip).forEach(function (k) { zoneByZip[k].polys.forEach(function (p) { p.setOptions({ fillOpacity: 0.35 }); }); });
        if (zip && zoneByZip[zip]) zoneByZip[zip].polys.forEach(function (p) { p.setOptions({ fillOpacity: 0.85 }); });
      }
      function showAt(zip, available, price, loc) {
        var far = false, anchor = loc || map.getCenter();
        if (loc && !zoneByZip[zip]) {
          if (miles(AUSTIN, { lat: loc.lat(), lng: loc.lng() }) > 150) { far = true; anchor = map.getCenter(); }
        }
        pop.show(anchor, popupHtml(zip, available, price));
        highlight(available ? zip : '');
        if (!far) { map.panTo(anchor); if (!zoneByZip[zip]) map.setZoom(11); }
      }
      function anchorAndShow(zip, available, price) {
        var c = centroid(zip);
        if (c) { showAt(zip, available, price, c); return; }
        if (geoCache[zip]) { showAt(zip, available, price, geoCache[zip]); return; }
        geocoder.geocode({ componentRestrictions: { postalCode: zip, country: 'US' } }, function (res, status) {
          var loc = (status === 'OK' && res[0]) ? res[0].geometry.location : null;
          if (loc) geoCache[zip] = loc;
          showAt(zip, available, price, loc);
        });
      }
      function doLookup(raw) {
        var zip = (raw || '').replace(/\D/g, '').slice(0, 5);
        if (input) input.value = zip;
        if (zip.length < 5) { pop.hide(); hideGeneral(); highlight(''); onResult(null); return; }
        var price = PRICE[zip], available = !!price;
        onResult({ zip: zip, available: available, price: price || null });
        if (available) {
          hideGeneral();
          anchorAndShow(zip, available, price);
        } else {
          // Not on our delivery list: don't geocode/pinpoint the ZIP — show one general popup
          // and reset the map to the coverage overview.
          pop.hide(); highlight('');
          map.panTo(AUSTIN); map.setZoom(9);
          showGeneral();
        }
      }

      if (input) input.addEventListener('input', function () { doLookup(input.value); });
      if (opts.form) { var f = el(opts.form); if (f) f.addEventListener('submit', function (e) { e.preventDefault(); doLookup(input && input.value); }); }
    }).catch(function () { if (errEl) errEl.hidden = false; });
  }

  window.NeuDeliveryMap = { create: create };
})();
